import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Link, Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import PropTypes from "prop-types";

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

/*

tabs = [
  {
    label: "Scenario Setup", this will appear as the tab title
    to: "/setup/scenario",
    value: "/setup/scenario"
  }
]

*/

const CustomTab = ({ tabs }) => {
	const [value, setValue] = useState(0);
	const pathname = useLocation().pathname.replace("/sims_ucb", "");

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ width: "100%" }}>
			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tabs value={pathname} onChange={handleChange}>
					{tabs.map((item, index) => {
						return (
							<Tab
								key={index}
								label={item.label}
								{...a11yProps(0)}
								sx={{ textTransform: "none" }}
								component={Link}
								to={item.to}
								value={item.value}
							/>
						);
					})}
				</Tabs>
			</Box>
			<Outlet />
		</Box>
	);
};

CustomTab.propTypes = {
	tabs: PropTypes.array.isRequired,
};

export default CustomTab;
